import { render } from "./LabelTextArea.vue?vue&type=template&id=826f5db6"
import script from "./LabelTextArea.vue?vue&type=script&lang=js"
export * from "./LabelTextArea.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__